import {
		Component,
		Input,
		OnInit,
		Output,
		EventEmitter
} from '@angular/core'
import { C } from '@angular/core/src/render3'
import { NotificationService } from 'src/app/services/notification.service'
import { SchedulingService } from 'src/app/services/scheduling.service'

@Component({
	selector: 'app-newService',
	templateUrl: './newService.component.html'
})
export class NewService implements OnInit {

		constructor(
				private readonly schedulingService: SchedulingService,
		  public notificationService: NotificationService
		) {}

		@Output() public close: any = new EventEmitter()
		@Output() public sendItens: any = new EventEmitter<string>()

		@Input() public itens: Array<{id: number, name: string}>

		public companyId: string = localStorage.getItem('companyId')
		public itensFiltred: Array<{id: number, name: string}>
		public searchItem: string

		public addNewItem: boolean = false
		public editItem: boolean = false

		public newItemName: string
		public editItemName: string
		public editingItemId: number

		public ngOnInit(): void {
				this.sortItens()

				this.itensFiltred = this.itens
		}

		public openNewIten() {
				this.addNewItem = true
		}

		public closeNewIten() {
				this.addNewItem = false
				this.newItemName = ''
		}

		public openEditIten(item) {
				this.editingItemId = item.id
				this.editItemName = item.name

				this.editItem = true
		}

		public closeEditIten() {
				this.editItem = false
		}

		public async addDemandServiceType() {
				await this.schedulingService.createDemandServiceType(
						this.newItemName,
						this.companyId
				).toPromise()
				.then(response => {
						const newItem = {
								id: response.content.id,
								name: this.newItemName
						}

						this.itens.push(newItem)
						this.itensFiltred = this.itens

						this.notificationService.notify(response.message, 200)
				})
				this.closeNewIten()
				this.sendItens.emit()
	}

		public async removeDemandServiceType(itemId: number) {
				await this.schedulingService.removeDemandServiceType(itemId).toPromise().then(response => {

						this.itens = this.itens.filter(item => item.id != itemId)
						this.itensFiltred = this.itens

						this.notificationService.notify(response.message, 200)
				})
		}

		public async editDemandServiceType() {
				await this.schedulingService.editDemandServiceType(this.editingItemId, this.editItemName)
				.toPromise().then(response => {

						this.itens.map(item => {
								if (item.id == this.editingItemId) {
										item.name = this.editItemName
								}
						})
						this.itensFiltred = this.itens

						this.notificationService.notify(response.message, 200)
				})
				this.closeEditIten()
				this.sendItens.emit()
		}

		public sortItens() {
				this.itens.sort((a, b) => {
						if (a.id < b.id) {
							return -1
						}
						if (a.id > b.id) {
							return 1
						}
						return 0
				})
		}

		public filterItens() {
				if (this.searchItem) {
						this.itensFiltred = this.itens.filter(iten => {
								const item = iten.name.toLowerCase()
								const search = this.searchItem.toLowerCase()

								if (Boolean(item.includes(search))) {
								return iten
								}
						})
				} else {
						this.itensFiltred = this.itens
				}
		}

		public closeModal() {
				this.close.emit()
		}
}
